<template>
  <div class="page-loading">
    <div class="d-flex justify-content-center vh-100">
      <div class="d-flex flex-column align-self-center logo-container">
        <!-- <img :src="logoUrl"> -->
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'PortalInitialization'
  // computed:{
  //   ...mapGetters({
  //     portalConfigurations: 'tenantDesign/config'
  //   }),
  //      logoUrl()
  //      {
  //      return this.portalConfigurations.general.logoUrl?this.portalConfigurations.general.logoUrl:'/Bazili-logo.png'
  //      }
  // },
}
</script>
